import {Component, Input, OnInit} from '@angular/core';

// models
import {Task} from '../../../shared/models/tasks/task';

// date picker
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import _moment from 'moment';

const moment = _moment;

export const DATE_FORMAT = {
    parse: {
        dateInput: ['YYYY-MM-DD']
    },
    display: {
        dateInput: 'DD/MM/Y',
        monthYearLabel: 'DD MM Y',
        dateA11yLabel: 'DD MM Y',
        monthYearA11yLabel: 'DD MM Y',
    },
};

@Component({
    selector: 'app-task-form',
    templateUrl: './task-form.component.html',
    styleUrl: './task-form.component.scss',
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        {provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT},
    ],
})

export class TaskFormComponent implements OnInit {

    @Input() public editMode = false;
    @Input() public task!: Task;

    public isLoading = false;
    public taskForm!: FormGroup;

    public deadlineDate = new FormControl<_moment.Moment | null>(moment());

    public nameMinLength = 3;
    public nameMaxLength = 120;
    public descriptionMinLength = 3;
    public descriptionMaxLength = 400;

    selectedTask = '';
    isDeadline = false;

    constructor(protected formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.buildTaskForm();
        this.setTaskPriority();
        if (this.editMode) {
            this.isLoading = true;
            setTimeout((): void => {
                this.setTask(this.task);
                this.isLoading = false;
            }, 500);
        }
    }

    public get taskPriority(): AbstractControl {
        return this.taskForm.controls['priority'];
    }

    public get taskName(): AbstractControl {
        return this.taskForm.controls['name'];
    }

    public get taskDescription(): AbstractControl {
        return this.taskForm.controls['description'];
    }

    public get taskDeadlineDate(): AbstractControl {
        return this.taskForm.controls['deadline'];
    }

    public setTaskPriority(): void {
        this.taskPriority.setValue('normalny');
        this.selectedTask = 'normalny';
    }

    public setCurrentDateTime(): void {
        if (this.isDeadline) {
            this.deadlineDate.setValue(moment());
            this.taskDeadlineDate.setValue(moment()?.format('YYYY-MM-DD'));
        } else
            this.taskDeadlineDate.setValue('');
    }

    public setTaskDeadlineDate(): void {
        this.taskDeadlineDate.setValue(this.deadlineDate.getRawValue()?.format('YYYY-MM-DD'));
    }

    private buildTaskForm(): void {
        this.taskForm = this.formBuilder.group({
            priority: ['', {validators: [Validators.required]}],
            name: ['', {
                validators: [Validators.required,
                    Validators.minLength(this.nameMinLength), Validators.maxLength(this.nameMaxLength)]
            }],
            description: ['', {
                validators: [Validators.minLength(this.descriptionMinLength), Validators.maxLength(this.descriptionMaxLength)]
            }],
            deadline: '',
        });
    }

    private setTask(task: Task): void {
        const {...formData} = task;
        this.taskForm.patchValue(formData);
        if (task.description) {
            this.taskDescription.setValue(task.description);
        } else this.taskDescription.setValue('');
        if (task.deadline) {
            this.isDeadline = true;
            this.taskDeadlineDate.setValue(task.deadline);
        } else this.taskDeadlineDate.setValue('');
    }
}
